export { default } from './UploaderView';
